const colors = {
	colors: {
		primaryColor: '#0071EB',
		secondaryColor: '#57DA10',
		tertiaryColor: '#596175',
		quaternaryColor: '#CCD0D9',
		quinaryColor: '#14254C',
	},
};

export default colors;
